import React from "react";
import "./CertificationSection.css";

const certificationLogos = [
  {
    id: 1,
    image:
      "/images/sedex-services.png",
    alt: "Sedex",
  },

  {
    id: 2,
    image:
      "/images/bifma.png",
    alt: "BIFMA",
  },

  {
    id: 3,
    image:
      "/images/riksh.jpg",
    alt: "riksh",
  },

  {
    id: 4,
    image:
      "/images/9001.webp",
    alt: "ISO 9001",
  },

  {
    id: 5,
    image:
      "/images/14001.png",
    alt: "ISO 14001",
  },

  {
    id: 6,
    image:
      "/images/45001.jpg",
    alt: "ISO 45001",
  },
];

/* DUPLICATE FOR INFINITE MOBILE LOOP */

const duplicatedLogos = [
  ...certificationLogos,
  ...certificationLogos,
];

export default function CertificationSection() {

  return (

    <section className="certification-main-section">

      <div className="certification-slider-wrapper">

        <div className="certification-container">

          {duplicatedLogos.map((logo, index) => (

            <div
              key={index}
              className={`certification-logo-card ${
                index >= certificationLogos.length
                  ? "desktop-hidden-logo"
                  : ""
              }`}
            >

              <img
                src={logo.image}
                alt={logo.alt}
                className="certification-logo-image"
              />

            </div>

          ))}

        </div>

      </div>

    </section>

  );
}